<template>
  <div class="payment-status-container">
    <h1 class="cancel-title">Die Reservierung ist fehlgeschlagen. ❌</h1>
    <p>Leider ist Ihre Reservierung fehlgeschlagen, da eine oder mehrere</p><p>der von Ihnen ausgewählten Zeiten nicht mehr verfügbar sind oder bereits gebucht wurden.</p>
    <p>Sie werden in {{ countdown }} Sekunden zur Startseite weitergeleitet...</p>

    <router-link to="/" class="home-link">Zurück zur Startseite</router-link>
  </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class ReservationFailed extends Vue {
  private countdown = 5

  mounted () {
    this.startCountdown()
  }

  startCountdown () {
    const interval = setInterval(() => {
      this.countdown--
      if (this.countdown <= 0) {
        clearInterval(interval)
        this.$router.push('/')
      }
    }, 1000)
  }
}
</script>

<style scoped>
.payment-status-container {
  max-width: 600px;
  margin: 80px auto;
  text-align: center;
}

.cancel-title {
  color: #d9534f;
}

.home-link {
  display: block;
  margin-top: 20px;
  color: #007bff;
}
</style>
